import React from "react";

function colorFor(change) {
  const c = Math.max(-5, Math.min(5, change));
  const t = (c + 5) / 10;
  if (t < 0.5) {
    const p = (0.5 - t) * 2;
    return `rgba(255, 77, 109, ${0.18 + p * 0.55})`;
  } else {
    const p = (t - 0.5) * 2;
    return `rgba(0, 255, 156, ${0.16 + p * 0.5})`;
  }
}

export default function Heatmap({ results }) {
  if (!results || results.length === 0) {
    return (
      <div className="card-surface p-6" data-testid="heatmap-empty">
        <div className="label-mono">Momentum Heatmap</div>
        <div className="text-white/50 text-sm mt-3">Run a scan to populate the heatmap.</div>
      </div>
    );
  }
  const sorted = [...results].sort((a, b) => Math.abs(b.change_pct) - Math.abs(a.change_pct)).slice(0, 30);
  return (
    <div className="card-surface p-5 fade-in" data-testid="heatmap">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="label-mono">Momentum</div>
          <h3 className="text-[15px] text-white font-semibold tracking-tight mt-0.5">Strongest movers</h3>
        </div>
        <div className="flex items-center gap-3 label-mono">
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded" style={{background: "rgba(255,77,109,0.6)"}}></span>Bear</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded" style={{background: "rgba(0,255,156,0.6)"}}></span>Bull</span>
        </div>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-10 gap-1.5">
        {sorted.map((r) => (
          <div key={r.ticker} data-testid={`heatmap-${r.ticker}`}
            className="heatmap-cell flex flex-col items-center justify-center p-2.5 rounded-xl cursor-pointer border border-white/5"
            style={{ background: colorFor(r.change_pct), minHeight: 76 }}>
            <div className="text-[12px] text-white font-semibold tracking-tight">{r.ticker}</div>
            <div className="font-mono text-[11px] mt-1 text-white tabular-nums">
              {r.change_pct >= 0 ? "+" : ""}{r.change_pct.toFixed(2)}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
